<template>
<div>
<ContentHeader  v-if="item"  :title="item.name"  :show_button="true"  icon="arrow-left" buttontype="danger" label=" Geri Dön" url="EducationpackVideos" ></ContentHeader>
<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
<div class="mt-4">

<ClickEditInputText  title="İsim" :value="item.name" valkey="name" @dataChanged="dataChanged($event)" />




<div class="grid"><div class="col-3 md:col-2"><p class="click_edit_value_title">Video Süresi:</p></div><!----><div class="col-9 md:col-10"><p class="click_edit_value animate_class">{{ $filters.videoduration( item.duration)}}</p></div></div>


<ClickEditUpload  title="Video Dosyası" :value="item.filename" :filepath="item.filepath" valkey="filename" @dataChanged="fileChanged($event)" />
<ProgressBar v-if="$store.state.ui.upload_progress>0 && upload_progress_element=='main_file_upload'" :value="$store.state.ui.upload_progress" class="mt-2 mb-2"/>
<hr>


<h4 class="text-primary pl-2">Çeviriler</h4>
<template v-for="translation in item.translations">
	<ClickEditInputText  :title="translation.language.name+' İsim'" :value="translation.translation" valkey="translation" @dataChanged="translationChanged($event,translation.id)" />
	<ClickEditInputTextArea  :title="translation.language.name+' Açıklama'" :value="translation.description" valkey="description" @dataChanged="translationChanged($event,translation.id)" />
  <ClickEditUpload  title="Video Dosyası" :value="translation.filename" :filepath="translation.filepath" valkey="filename" @dataChanged="translationFileChanged($event,translation.id)" />
  <ProgressBar v-if="$store.state.ui.upload_progress>0  &&upload_progress_element=='translation_file_upload'+translation.id" :value="$store.state.ui.upload_progress" class="mt-2 mb-2"/>
</template>

</div>
</template>
</div>
</template> 

<script>
import nanoMetadata from 'nano-metadata'
export default {

  name: 'EducationpackVideo',

  data () {
    return {
    	item:null,
    	loading:true,
    	languages:[],
      upload_progress_element:null,
    }
  },
  mounted()
  {
  	this.getData()
  },
  methods:{
  	async getData()
    {
    	console.log(this.$route.params.video_id)
    	this.languages = await this.generalApiGetWithoutLoader("languages")
        this.item = await this.generalApiGetWithoutLoader("educationvideo/"+this.$route.params.video_id)
        await this.$store.dispatch('questions/setQuestion',this.item)
        console.log(this.item)

        this.loading = await false
    },   
    dataChanged(data)
    {
      console.log(data.value)
      console.log(data.key)
      //return false
      let formdata = new FormData()
      formdata.append(data.key,data.value)      
      this.generalSubmission(formdata,"educationvideo/"+this.item.id,this.afterdataChanged)
    },
    async getVideoMeta(file)
    {
      
      let fileduration 
      await nanoMetadata.video.duration(file).then((duration) => {
        console.log("nanoMetadata")
        console.log(duration)
        fileduration = duration
      })

       return await fileduration
    },
    async fileChanged(data)
    {
      console.log(data.value)
      console.log(data.key)
      //return false
      this.upload_progress_element = await "main_file_upload"
      let formdata = new FormData()
      await formdata.append(data.key,data.value)

      await formdata.append('video_file', data.value[0]);   
      let duration =  await this.getVideoMeta(data.value[0])   
      await formdata.append("duration",Math.floor(duration))
      await this.generalSubmissionWithProgress(formdata,"educationvideo_file/"+this.item.id,this.afterdataChanged)
    },
    translationChanged(data,id)
    {
      console.log(data.value)
      console.log(data.key)
      //return false
      let formdata = new FormData()
      formdata.append(data.key,data.value)      
      this.generalSubmission(formdata,"educationvideo_translation/"+id,this.afterdataChanged)

    },
    async translationFileChanged(data,id)
    {
      this.upload_progress_element = await "translation_file_upload"+id
      await console.log(data.value)
      await console.log(data.key)
      //return false
      let formdata = new FormData()
      await formdata.append(data.key,data.value)

      await formdata.append('video_file', data.value[0]);  
      let duration =  await this.getVideoMeta(data.value[0])  
      await formdata.append("duration",Math.floor(duration))  
      await this.generalSubmissionWithProgress(formdata,"educationvideotranslation_file/"+id,this.afterdataChanged)
    },
    afterdataChanged(response)
    {
      console.log(response);      
      this.item = response.data
      this.$store.dispatch('questions/setQuestion',this.item)
      this.upload_progress_element = null
    },
  }
}
</script>

<style lang="css" scoped>
</style>